import React from 'react';
import { Form, Input, Select, Col, Row, InputNumber, message } from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import { dicHouseStatus, direction } from '../../../../axios/dictionaries';
import { handleExportParams } from '../../../../utils';
import { API_houseType_findList } from '../../../../axios/config';

const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "新增房源",
            data: {},
            buildingData: [],
            roomTypeList: [],
            buildingDetail: {},
        }
    }

    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue, getFieldValue } } = this.props;
        let {
            loading,
            title,
            data,
            buildingData,
            buildingDetail,
        } = this.state;
        let newDicHouseStatus = [].concat(dicHouseStatus);
        newDicHouseStatus.splice(1, 1);

        const jrRoomId = data.jrRoomId

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
               >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <DetailTitle title="房源信息" boxStyle={{ marginTop: '0' }} />
                            <CustomRow>
                                <CustomCol label="小区/楼栋">
                                    {getFieldDecorator('buildingId', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.buildingId
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            onChange={(value) => { //切换小区/楼栋
                                                if (value === data.buildingId) {
                                                    setFieldsValue({ layout: data.layout, floor: data.floor });
                                                } else {
                                                    setFieldsValue({ layout: undefined });
                                                }
                                                this.loadBuildingDetail({ buildingId: value });
                                                this.loadRoomTypeList(value)
                                            }}
                                            optionFilterProp={'children'}
                                        >
                                            {buildingData.map((item, index) => <Option value={item.id} key={item.id}>{item.name}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="楼层" subfix={<div>/{buildingDetail.floorCount}层</div>} subfixRight={30}>
                                    {getFieldDecorator('floor', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.floor
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            style={{ paddingRight: '60px' }}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="房号">
                                    {getFieldDecorator('roomNo', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.roomNo
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            max={10}
                                            disabled={!!jrRoomId}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="房源编号">
                                    {getFieldDecorator('houseNo', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.houseNo
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            maxLength={99}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="租赁状态">
                                    {getFieldDecorator('status', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.status || 1
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {newDicHouseStatus.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                {
                                    this.isJr() &&
                                    <CustomCol label="租金">
                                        {getFieldDecorator('rent', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.rent
                                        })(
                                            <InputNumber
                                                min={10}
                                                max={100000}
                                                placeholder="范围：10-100000"
                                            />

                                        )}
                                    </CustomCol>
                                }
                            </CustomRow>
                            {
                                this.isJr() &&
                                <CustomRow divider>
                                    <CustomCol label="房源户型">
                                    {getFieldDecorator('ccbRoomTypeId', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.ccbRoomTypeId
                                        })(
                                            <Select
                                                showSearch
                                                placeholder="请选择"
                                                optionFilterProp={'children'}
                                            >
                                                {this.state.roomTypeList.map((item, index) => <Option value={item.id} key={item.id}>{item.roomTypeName}</Option>)}
                                            </Select>
                                        )}
                                    </CustomCol>
                                    <CustomCol label="所属楼栋">
                                        {getFieldDecorator('attributionBuilding', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.attributionBuilding
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                                maxLength={10}
                                                disabled={!!jrRoomId}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="所属单元">
                                        {getFieldDecorator('unit', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.unit
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                                maxLength={10}
                                                disabled={!!jrRoomId}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                            }

                            <DetailTitle title="户型信息" />
                            <CustomRow>
                                {
                                    !this.isJr()&&
                                    <CustomCol label="户型" required={false}>
                                        {getFieldDecorator('layout', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: data.layout
                                        })(
                                            <Select
                                                showSearch
                                                placeholder="请选择"
                                                optionFilterProp={'children'}
                                            >
                                                {
                                                    buildingDetail.houseLayout instanceof Array
                                                        ? buildingDetail.houseLayout.map((item, index) => <Option
                                                            value={`${item.f}房${item.t}厅${item.w}卫`}
                                                            key={item.id}>{`${item.f}房${item.t}厅${item.w}卫`}</Option>)
                                                        : null
                                                }
                                            </Select>
                                        )}
                                    </CustomCol>
                                }
                                <CustomCol required={false} label="面积" subfix={<div>m²</div>} subfixRight={30}>
                                    {getFieldDecorator('area', {
                                        initialValue: data.area
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            maxLength={8}
                                            style={{ paddingRight: '60px' }}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol required={false} label="朝向">
                                    {getFieldDecorator('direct', {
                                        initialValue: data.direct
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {direction.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }



    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {}, buildingData: [], buildingDetail: {}, loading: false, title: "新增房源" });
    }

    loadBuildingList = () => {
        postFrom({ url: config.API_building_findBuildingList, data: {} }).then(res => {
            this.setState({ buildingData: res });
        }).catch(err => {
            message.error(err.message || '获取小区/楼栋列表失败');
        });
    }
    loadRoomTypeList = (ccbProjectId) => {
        post({ url: API_houseType_findList, data: {ccbProjectId} }).then(res => {
            this.setState({ roomTypeList: res })
        })
    }

    isJr=() =>{
        return handleExportParams().isJr === 1;
    }

    loadBuildingDetail = ({ buildingId }) => {
        postFrom({ url: config.API_building_getBuildingById, data: { keyword: buildingId, } }).then(res => {
            this.setState({ buildingDetail: res });
        }).catch(err => {
            message.error(err.message || '获取户型信息失败');
        });
    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "编辑房源" });
        let data = { houseId: id };
        postFrom({ url: config.API_house_getHouseById, data }).then(res => {
            this.loadBuildingDetail({ buildingId: res.buildingId });
            this.loadRoomTypeList(res.buildingId)
            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let loginData = Cookies.get('loginData');
                if (loginData) {
                    loginData = JSON.parse(loginData);
                    values.merchantId = loginData.merchantId ? loginData.merchantId : 0;
                } else {
                    message.error('未登录')
                    return
                }

                this.setState({ loading: true });

                let building = this.state.buildingData.find((item) => values.buildingId === item.id);
                values.name = building.name;
                // values.attributionBuilding = building.name;

                if (values.id) {
                    values.houseId = values.id;
                    post({ url: config.API_house_edit, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    post({ url: config.API_house_create, data: values }).then(res => {
                        message.success('新增成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '新增失败');
                        this.setState({ loading: false });
                    })
                }
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/House/components/MaintainAdd/index.js